import { Link } from 'react-router-dom';

export default function PublicFooter() {
  return (
    <footer className="pub-footer" data-testid="pub-footer">
      <div className="pub-container">
        <div className="py-16">
          {/* Top row */}
          <div className="grid grid-cols-1 md:grid-cols-[1fr_auto_auto] gap-12 md:gap-16">
            {/* Brand */}
            <div>
              <span
                className="font-wordmark text-white block leading-none mb-2"
                style={{ fontSize: '27px' }}
                aria-label="KYRDROS"
              >
                KYRDROS
              </span>
              <p className="pub-body" style={{ color: '#98a2b3', fontSize: '13px', marginTop: '6px', maxWidth: '260px', lineHeight: 1.6 }}>
                The Superintelligence Governor.
              </p>
            </div>

            {/* Product links */}
            <div>
              <p className="font-heading font-semibold text-white mb-4" style={{ fontSize: '12px', letterSpacing: '0.08em', textTransform: 'uppercase' }}>
                Product
              </p>
              <ul className="space-y-3">
                {[
                  { label: 'Overview',     href: '/#product' },
                  { label: 'How It Works', href: '/#how-it-works' },
                  { label: 'Capabilities', href: '/#capabilities' },
                ].map(l => (
                  <li key={l.label}>
                    <a href={l.href} style={{ fontFamily: 'Helvetica, Arial, sans-serif', fontSize: '14px', color: '#98a2b3', textDecoration: 'none', transition: 'color 0.15s' }}
                       onMouseOver={e => e.target.style.color='#fff'}
                       onMouseOut={e => e.target.style.color='#98a2b3'}>
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Company links */}
            <div>
              <p className="font-heading font-semibold text-white mb-4" style={{ fontSize: '12px', letterSpacing: '0.08em', textTransform: 'uppercase' }}>
                Company
              </p>
              <ul className="space-y-3">
                {[
                  { label: 'About',       href: '/about' },
                  { label: 'Enterprise',  href: '/enterprise' },
                  { label: 'Login',       href: '/login' },
                ].map(l => (
                  <li key={l.label}>
                    <Link to={l.href} style={{ fontFamily: 'Helvetica, Arial, sans-serif', fontSize: '14px', color: '#98a2b3', textDecoration: 'none', transition: 'color 0.15s' }}
                          onMouseOver={e => e.target.style.color='#fff'}
                          onMouseOut={e => e.target.style.color='#98a2b3'}>
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div
          style={{ borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: '24px', paddingBottom: '32px' }}
          className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4"
        >
          <p data-testid="footer-tagline" style={{ fontFamily: 'Helvetica, Arial, sans-serif', fontSize: '12px', color: '#8a94a6', lineHeight: 1.5, maxWidth: '480px' }}>
            KYRDROS connects organizational knowledge, evidence, and AI-assisted reasoning under accountable human authority.
          </p>
          <div
            aria-label="From Durahuman"
            data-testid="footer-from-durahuman"
            style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '4px', marginTop: 0 }}
          >
            <span style={{ fontFamily: 'Helvetica, Arial, sans-serif', fontSize: '10px', color: '#8a94a6', letterSpacing: '0.04em' }}>From</span>
            <img
              src="/images/durahuman-wordmark-transparent.png"
              alt="DURAHUMAN"
              style={{ width: '120px', height: 'auto', opacity: 0.75 }}
              draggable="false"
            />
          </div>
        </div>
      </div>
    </footer>
  );
}
